import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateLenderClosingReasons } from "@/shared/store/LenderCallLog/LenderClosingReasons";

const getLenderClosingReasons = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLenderClosingReasons: builder.query({
      query: () => "parameters/lender-call-log-lender-closing-reasons",
      transformResponse: response => response.items,
      providesTags: ["LenderClosingReasons"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateLenderClosingReasons(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderClosingReasonsQuery } = getLenderClosingReasons;

